import { EventTimeHelper } from "app/helpers/eventTimeHelper";
import React from "react";

const EventPhaseEventTime = (
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<"div">, "div"> => {
  const {
    eventData,
    eventIncidents,
    isBeforeExtra,
    isEventInExtraTime,
    screenType,
  } = props;
  return (
    <span>
      {EventTimeHelper.getEventTimeComponent(
        eventData,
        eventIncidents,
        isBeforeExtra,
        isEventInExtraTime,
        screenType
      )}
    </span>
  );
};

export default EventPhaseEventTime;
